import React, { CSSProperties, useEffect, useState } from 'react';
import { debounce, makeStyles, withStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import { useSnackbar } from 'notistack';
import { format, isValid, parseISO, isDate } from 'date-fns';
import { HVcGrid, SymbolDiv, VcGrid } from 'components/Grid';
import { dDaFormatP, dTi4Format, dTi4FormatP } from 'main_consts';
import { dateTypingChange, timeTypingChange } from 'main_func';
import { dateErrStr, IupdateObj } from '.';
import TimePickerTyping from './TimePickerTyping';
import DatePickerTyping from './DatePickerTyping';
import { dateValue, seDaTimeVerify, timeValue } from './consts';

interface IDateTimeOneSePickersTyping {
  names: [[string, string], [string, string]];
  disabled?: boolean;
  required?: boolean;
  mainClass?: string;
  verifyError?: boolean;
  data: unknown;
  updateData: (updateObj: IupdateObj) => void;
  style?: CSSProperties;
  setDayRange?: number;
  // daFormat?: typeof dDaFormat;
  daFormatP?: typeof dDaFormatP;
  tiFormat?: typeof dTi4Format;
  tiFormatP?: typeof dTi4FormatP;
}

let timer: NodeJS.Timeout;
export const timerDebounce = (func: () => void, delay = 1000): void => {
  if (timer) {
    clearInterval(timer);
  }
  timer = setTimeout(func, delay);
};

/**
 * 1. 監聽 4 個欄位，並自動新增/更新檢核欄位 [`${field}Valid`] = boolean,
 *    ex: {
 *      startDate: "20210323",
 *      startTime: "0000",
 *      startDateValid: true,
 *      startTimeValid: true,
 *    }
 *
 */

const useStyles = makeStyles(() => ({
  errorText: {
    '& .MuiFormHelperText-root': { fontSize: '1em' },
  },
}));
const DateTimeOneSePickersTyping = (
  props: IDateTimeOneSePickersTyping
): JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    disabled = false,
    names,
    required = false,
    mainClass,
    verifyError,
    data: dataTemp,
    updateData,
    style = {},
    setDayRange: seInterval,
    daFormatP = dDaFormatP,
    tiFormat = dTi4Format,
    tiFormatP = dTi4FormatP,
  } = props;

  const classes = useStyles();
  const data = dataTemp as IupdateObj<string>;

  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [startTime, setStartTime] = useState<Date | null>(new Date());

  useEffect(() => {
    const valueDate = [
      dateValue(data[names[0][0]], data[names[0][1]]),
      timeValue(data[names[0][0]], data[names[0][1]]),
    ].map((obj) => (isValid(obj) ? obj : null));

    setStartDate(valueDate[0]);
    setStartTime(valueDate[1]);

    const nullOrValid = (d: string | Date | null, dStr: string) =>
      dStr === '' || isValid(d);

    updateData({
      [`${names[0][0]}Valid`]: nullOrValid(valueDate[0], data[names[0][0]]),
      [`${names[0][1]}Valid`]: nullOrValid(valueDate[1], data[names[0][1]]),
    });
  }, [data[names[0][0]], data[names[0][1]]]);

  const Pickers = [
    <DatePickerTyping
      className={classes.errorText}
      disabled={disabled}
      required={required}
      verifyBeforeChange={verifyError}
      format={daFormatP}
      value={startDate}
      onChange={(date) => {
        setStartDate(date);
        const name = names[0][0];
        dateTypingChange(updateData)(name)(date);
        if (isValid(date)) {
          const func = debounce(() => {
            isDate(date);
          });
          func();
        }
      }}
    />,
    <TimePickerTyping
      className={classes.errorText}
      ampm={false}
      disabled={disabled}
      required={required}
      verifyBeforeChange={verifyError}
      format={tiFormatP}
      value={startTime}
      onChange={(date) => {
        setStartTime(date);
        const name = names[0][1];
        timeTypingChange(updateData)(name)(date);
        if (isValid(date)) {
          const func = debounce(() => {
            const a = data[names[0][0]];
            const b = date ? format(date, tiFormat) : '';

            // if (a) {
            //   enqueueSnackbar(dateErrStr);
            // }
          });
          func();
        }
      }}
    />,
  ];

  const VcGridWithCont = withStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      '& > div': {
        display: 'contents',
      },
    },
  })(VcGrid);

  return (
    <div className={mainClass} style={{ ...style, width: '100%' }}>
      {/* sm 以下時消失 */}
      <Hidden smDown>
        <VcGrid container>
          <VcGrid item xs={4}>
            {Pickers[0]}
          </VcGrid>
          <SymbolDiv />
          <VcGrid item xs={4}>
            {Pickers[1]}
          </VcGrid>
        </VcGrid>
      </Hidden>
      {/* md 以上時消失 */}
      <Hidden mdUp>
        <VcGrid container>
          <VcGridWithCont item xs>
            {Pickers[0]}
          </VcGridWithCont>
          <SymbolDiv />
          <VcGridWithCont item xs>
            {Pickers[1]}
          </VcGridWithCont>
        </VcGrid>
      </Hidden>
    </div>
  );
};

export default DateTimeOneSePickersTyping;
